import { FeedbackCard } from "@/components/pieces/roleplays/FeedbackCard";
import { RankDisplay } from "@/components/pieces/roleplays/RankDisplay";
import { CTA_COLOR, GREEN, YELLOW } from "@/css/constants";
import { FullRoleplaySession } from "@/types/roleplays";

interface SummaryProps {
  roleplaySession: FullRoleplaySession;
}

export function Summary({ roleplaySession }: SummaryProps) {
  if (!roleplaySession) return null;

  return (
    <>
      <RankDisplay rank={roleplaySession.rank} score={roleplaySession.score} />
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-6 mt-6">
        <div className="sm:col-span-2">
          <FeedbackCard
            icon="lightning"
            title="Objective Attainment"
            content={roleplaySession.outcomeFeedback}
            iconColor={CTA_COLOR}
          />
        </div>
        <FeedbackCard
          icon={"thumbs-up"}
          title="What Went Well"
          content={roleplaySession.positiveFeedback}
          iconColor={GREEN}
        />
        <FeedbackCard
          icon={"lightbulb"}
          title="Room for Improvement"
          content={roleplaySession.constructiveFeedback}
          iconColor={YELLOW}
        />
      </div>
    </>
  );
}
